import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Envelope, MapPin, Globe, Buildings, Certificate } from '@phosphor-icons/react';

const Contact = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: '-100px' });

    const companyInfo = [
        {
            icon: Buildings,
            label: 'Company Name',
            value: 'Spindrift Engineering Limited',
            link: null
        },
        {
            icon: Certificate,
            label: 'Registration Number',
            value: 'SC715585',
            link: null
        },
        {
            icon: MapPin,
            label: 'Registered Address',
            value: 'Da Noost Friester, South Nesting, Shetland, Scotland, ZE2 9PP',
            link: null
        },
        {
            icon: Globe,
            label: 'Website',
            value: 'spindrift-eng.com',
            link: 'https://spindrift-eng.com'
        },
        {
            icon: Envelope,
            label: 'Email',
            value: 'info@spindrift-eng.com',
            link: 'mailto:info@spindrift-eng.com'
        }
    ];

    return (
        <section 
            id="contact" 
            className="py-24 sm:py-32 bg-background-surface"
            data-testid="contact-section"
            ref={ref}
        >
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Section Header */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-12"
                >
                    <span className="text-sm uppercase tracking-[0.2em] font-bold text-secondary">
                        Get in Touch
                    </span>
                    <h2 className="text-3xl sm:text-4xl font-medium tracking-tight text-text-primary mt-4">
                        Contact & Company Information
                    </h2>
                    <p className="text-text-secondary mt-4">
                        Interested in our products or services? We'd love to hear from you.
                    </p>
                </motion.div>

                {/* Info Grid */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="grid grid-cols-1 sm:grid-cols-2 gap-6"
                >
                    {companyInfo.map((item, index) => (
                        <div 
                            key={item.label}
                            className="flex gap-4 p-4 bg-background-base border border-border-subtle rounded-sm"
                            data-testid={`contact-${item.label.toLowerCase().replace(' ', '-')}`}
                        >
                            <div className="flex-shrink-0 w-10 h-10 bg-background-elevated rounded-sm flex items-center justify-center">
                                <item.icon size={20} weight="duotone" className="text-secondary" />
                            </div>
                            <div>
                                <p className="text-xs uppercase tracking-wider text-text-muted mb-1">
                                    {item.label}
                                </p>
                                {item.link ? (
                                    <a 
                                        href={item.link}
                                        className="text-text-primary hover:text-secondary transition-colors text-sm"
                                        target={item.link.startsWith('http') ? '_blank' : undefined}
                                        rel={item.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                                    >
                                        {item.value}
                                    </a>
                                ) : (
                                    <p className="text-text-primary text-sm">
                                        {item.value}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default Contact;
